import { Alert, Box, Typography } from 'ui/mui';

const DownloadStatus = ({
  errorMessage,
  successMessage,
  downloadProgress,
}: {
  errorMessage: string | null;
  successMessage: string | null;
  downloadProgress: number | undefined;
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
    }}
  >
    {downloadProgress !== undefined && (
      <Typography variant='h6' component={'span'} sx={{ mb: 2 }}>
        Laddar ner - <strong>{downloadProgress}%</strong>
      </Typography>
    )}
    {errorMessage && (
      <Alert severity='error' sx={{ mb: 2, width: '100%' }}>
        {errorMessage}
      </Alert>
    )}
    {successMessage && (
      <Alert severity='success' sx={{ mb: 2, width: '100%' }}>
        {successMessage}
      </Alert>
    )}
  </Box>
);
export default DownloadStatus;
